import invalidCartRedirectMiddleware from '#shared/middleware/invalidCartRedirectMiddleware.js';
import getCartMiddleware from '#shared/middleware/getCartMiddleware.js';

import defaultCompanyDetails from '#themes/default/default/pages/companyDetails/companyDetails.js';

import cButton from '#themes/default/web/components/button/button.js';
import cButtons from '#themes/default/web/components/buttons/buttons.js';
import cContentLayout from '#themes/default/web/layouts/contentLayout/contentLayout.js';
import cFormLine from '#themes/default/web/components/formLine/formLine.js';
import cHeader from '#themes/default/web/components/header/header.js';
import cInput from '#themes/default/web/components/input/input.js';
import cSkeleton from '#themes/default/web/components/skeleton/skeleton.js';

export default {
	middleware: [
		invalidCartRedirectMiddleware,
		getCartMiddleware
	],
	components: {
		cButton,
		cButtons,
		cContentLayout,
		cFormLine,
		cHeader,
		cInput,
		cSkeleton
	},
	extends: defaultCompanyDetails
};
